export const appHomeHero = {
    create: function(){
        var that = this;
        if($('.js-home-hero').length){
            var swiper = new Swiper('.js-home-hero', {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    keyboard: {
                    enabled: true,
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: ".js-home-hero-next",
                        prevEl: ".js-home-hero-prev",
                    },
                    a11y: {
                        enabled: false,
                    },
					on: {
						init: function () {
							// Set aria-labels dynamically from markup
							const nextButton = document.querySelector('.js-home-hero-next');
							const prevButton = document.querySelector('.js-home-hero-prev');
							
							if (nextButton) {
								nextButton.setAttribute('aria-label', document.querySelector('.js-home-hero-next').getAttribute('data-aria-label'));
							}
							if (prevButton) {
								prevButton.setAttribute('aria-label', document.querySelector('.js-home-hero-prev').getAttribute('data-aria-label'));
							}
						},
					},
                });
            //console.log(swiper);
        }
    }
}
